// src/audio/TrackPlayerService.js
//
// react-native-track-player requires a registered playback service. In Expo
// managed workflow the service runs in the SAME JavaScript context as the app
// (the RN JS thread stays alive while audio plays with staysActiveInBackground).
// However, to avoid any ambiguity about which AudioEngine instance is being
// called, we keep this service as a minimal no-op stub and register all remote-
// command handlers in LockScreenControls.init() (app context, after AudioEngine
// is ready). The service must exist and be registered — RNTP will throw without
// it — but the actual control dispatch happens in the app's JS runtime.
//
// See: https://rntp.dev/docs/basics/playback-service

export async function PlaybackService() {
  // Intentionally empty. Remote command handlers (RemotePlay, RemotePause,
  // RemoteStop) are registered in LockScreenControls.init() in the app context
  // so they share the exact same AudioEngine singleton and expo-av sound objects
  // that are managing playback.
}
